import type { BuildOrganizationServicesCollectionPathParams } from '../types';

const buildOrganizationServicesCollectionPath = ({
    organizationId,
}: BuildOrganizationServicesCollectionPathParams): string =>
    `/admin/organizations/${encodeURIComponent(organizationId)}/services`;

export default buildOrganizationServicesCollectionPath;
